import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import ConfirmationModal from "@componentsShared/Confirmation/ConfirmationModal";
import { useConfirmation } from "@hooks/useConfirmation";
import { createStepSchema, useDynamicForm } from "@/pages/finance-eligibility/context/ScreenContext";
import { useFormContext } from "react-hook-form";
import { trackEvents } from "@/common/events/events";
var StepperHeader = function StepperHeader() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useConfirmation = useConfirmation(),
    confirmationHandlers = _useConfirmation.confirmationHandlers,
    confirmation = _useConfirmation.confirmation,
    awaitConfirmation = _useConfirmation.awaitConfirmation;
  var _useDynamicForm = useDynamicForm(),
    currentStep = _useDynamicForm.currentStep,
    visitedSteps = _useDynamicForm.visitedSteps,
    setState = _useDynamicForm.setState,
    state = _useDynamicForm.state,
    initialStepId = _useDynamicForm.initialStepId;
  var _useFormContext = useFormContext(),
    unregister = _useFormContext.unregister;
  var goBack = function goBack() {
    if (currentStep.id === initialStepId) return;
    if (!(currentStep !== null && currentStep !== void 0 && currentStep.previous_id)) return;
    var previousStepId = currentStep.previous_id;
    var stepsToReset = Array.from(visitedSteps).filter(function (stepId) {
      return stepId >= previousStepId;
    });
    stepsToReset.forEach(function (stepId) {
      var _state$steps;
      var step = state === null || state === void 0 ? void 0 : (_state$steps = state.steps) === null || _state$steps === void 0 ? void 0 : _state$steps.find(function (s) {
        return s.id === stepId;
      });
      if (step) {
        var schema = createStepSchema(step);
        // @ts-ignore
        Object.keys(schema.shape).forEach(function (fieldName) {
          unregister(fieldName);
        });
      }
    });
    var newVisitedSteps = new Set(Array.from(visitedSteps).filter(function (stepId) {
      return !stepsToReset.includes(stepId) || stepId === previousStepId;
    }));
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      visitedSteps: newVisitedSteps,
      currentStepId: previousStepId
    });
    setState(newState);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
  }, currentStep.id !== initialStepId && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.previous_id) && /*#__PURE__*/React.createElement("div", {
    className: "en:transform en:rotate-180",
    onClick: goBack
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    width: 4,
    height: 4,
    variant: "primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer text-gray-text text-xs font-semibold lg:hidden",
    role: "button",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var isConfirmed;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return awaitConfirmation();
          case 2:
            isConfirmed = _context.sent;
            if (isConfirmed) {
              sessionStorage.removeItem("eligibility_data");
              sessionStorage.removeItem("submission_source");
              trackEvents("eligibility_check_cancel", {
                question_id: currentStep === null || currentStep === void 0 ? void 0 : currentStep.id
              });
              history.back();
            } else {
              confirmation.setFalse();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))
  }, t("إلغاء", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(ConfirmationModal, {
    variant: "default",
    title: t("هل انت متأكد من الإلغاء", {
      ns: "saved_search"
    }),
    isOpen: confirmation.value,
    cancelText: t("متابعة الطلب", {
      ns: "web_common"
    }),
    confirmText: t("إلغاء الطلب", {
      ns: "web_common"
    }),
    onClose: function onClose() {
      return confirmationHandlers === null || confirmationHandlers === void 0 ? void 0 : confirmationHandlers.handleCancel();
    },
    onConfirm: function onConfirm() {
      return confirmationHandlers === null || confirmationHandlers === void 0 ? void 0 : confirmationHandlers.handleConfirm();
    }
  }));
};
export default StepperHeader;